import { JDSContainerProps } from './generated';
import { convertTextToComponent } from '../../utils/componenthelpers';
import { forwardRef } from 'react';

export interface ContainerProps
  extends Omit<
    JDSContainerProps,
    | 'width'
    | 'radius'
    | 'gap'
    | 'paddingTop'
    | 'paddingRight'
    | 'paddingBottom'
    | 'paddingLeft'
    | 'flex'
    | 'height'
    | 'borderColor'
    | 'direction'
  > {
  direction?: 'row' | 'column';
  width?: string | number;
  radius?: string | number;
  padding?: Array<number>;
  gap?: string | number;
  borderWidth?: Array<number>;
  borderColor?: string;
  fullWidth?: boolean;
  paddingLeft?: string | number;
  paddingRight?: string | number;
  paddingTop?: string | number;
  paddingBottom?: string | number;
  flex?: number;
  height?: string | number;
  style?: React.HTMLAttributes<HTMLDivElement>['style'];
}

export const withLogic = (
  Component: React.ComponentType<ContainerProps>
): React.FC<ContainerProps> =>
  forwardRef<HTMLDivElement, ContainerProps>((props: ContainerProps, ref) => {
    const [borderTop, borderRight, borderBottom, borderLeft] =
      props.borderWidth || [];
    const [paddingTop, paddingRight, paddingBottom, paddingLeft] =
      props.padding || [];

    return (
      <Component
        {...{
          ...props,
          rootRef: ref,
          children: convertTextToComponent(props.children),
          width: props.fullWidth ? '{size.max}' : props.width,
          borderTopWidth: borderTop || props.borderTopWidth,
          borderLeftWidth: borderLeft || props.borderLeftWidth,
          borderRightWidth: borderRight || props.borderLeftWidth,
          borderBottomWidth: borderBottom || props.borderLeftWidth,
          paddingTop: paddingTop || props.paddingTop,
          paddingBottom: paddingBottom || props.paddingBottom,
          paddingRight: paddingRight || props.paddingRight,
          paddingLeft: paddingLeft || props.paddingLeft
        }}
      />
    );
  });
